module.exports = __webpack_public_path__ + "img/company-honor-RoHS-20240531.ecd5ff72.jpg";